import { createWalletClient, custom } from 'viem';
import { PrivyConnector } from '@privy-io/wagmi-connector';
import { ECDSAProvider, getRPCProviderOwner } from '@zerodev/sdk';
import { getProjectsConfiguration } from '../../utilities/getProjectsConfiguration';
export class ZeroDevPrivyConnector extends PrivyConnector {
    constructor({ logout, chains, activeWallet, options, kernelAddress, }) {
        super({ logout, chains, activeWallet });
        this.chainIdProjectIdMap = {};
        this.onChainChanged = (chainId) => {
            this.ecdsaProvider = undefined;
            return super.onChainChanged(chainId);
        };
        this.onAccountsChanged = (accounts) => {
            this.ecdsaProvider = undefined;
            return super.onAccountsChanged(accounts);
        };
        if (!options?.projectId && !options?.projectIds)
            throw Error('Please provide a projectId or projectIds');
        if (!options.projectId && options.projectIds)
            options.projectId = options.projectIds[0];
        if (options.projectId && !options.projectIds)
            options.projectIds = [options.projectId];
        this.kernelAddress = kernelAddress;
        this.projectsConfiguration = getProjectsConfiguration(options.projectIds);
    }
    async getProjectIdFromChainId(chainId) {
        if (!this.chainIdProjectIdMap[chainId]) {
            const projectId = (await this.projectsConfiguration).projects?.find(project => project.chainId === chainId)?.id;
            if (projectId) {
                this.chainIdProjectIdMap[chainId] = projectId;
            }
        }
        return this.chainIdProjectIdMap[chainId];
    }
    async getAccount() {
        return await (await this.getECDSAProvider()).getAddress();
    }
    async switchChain(chainId) {
        return super.switchChain(chainId);
    }
    async getECDSAProvider() {
        if (!this.ecdsaProvider) {
            this.ecdsaProvider = await ECDSAProvider.init({
                projectId: await this.getProjectIdFromChainId(await this.getChainId()),
                owner: getRPCProviderOwner(await this.getProvider()),
                opts: {
                    accountConfig: {
                        accountAddress: this.kernelAddress,
                    },
                }
            });
        }
        return this.ecdsaProvider;
    }
    async getWalletClient({ chainId } = {}) {
        const chain = this.chains.find((x) => x.id === chainId);
        const ecdsaProvider = await this.getECDSAProvider();
        const walletClient = createWalletClient({
            account: await this.getAccount(),
            chain,
            transport: custom(ecdsaProvider),
        });
        walletClient.ecdsaProvider = ecdsaProvider;
        return walletClient;
    }
}
